import React from 'react';
import { Radio } from 'antd';
import { useDidMount } from '../../use';
import getUdc from '../../../service/udc';
import { generators } from '../../../utils';

const soryByCode = (a, b) => {
  const value1 = a['code'];
  const value2 = b['code'];
  return value1 - value2;
};

const AsyncRadio = ({ type, ...rest }, ref) => {
  const [dataSource, setDataSource] = React.useState([]);
  const fetchData = async () => {
    const response = await getUdc(type);
    if (response.success) {
      const dataSource = generators.generatorArray(response.data);
      setDataSource(dataSource.sort(soryByCode));
    }
  };
  useDidMount(() => fetchData());
  return (
    <Radio.Group ref={ref} {...rest}>
      {dataSource.map(({ code, name }) => (
        <Radio value={code} key={code}>
          {name}
        </Radio>
      ))}
    </Radio.Group>
  );
};
export default React.forwardRef(AsyncRadio);
